import React, { Component } from 'react';
import './VizPaises.css';

import 'typeface-pt-sans';
import 'bootstrap/dist/css/bootstrap.css';
import { Row, Col } from 'reactstrap';
import * as d3 from 'd3v4';

import { Mapa } from './Mapa';
import { InfoPais } from './InfoPais';
import { Encabezado } from './Encabezado';
import { EscalaColores } from './EscalaColores';
import { BarrasPaises } from './BarrasPaises';
import { SSemiFixedContainer, SFixed, SStretch } from './SemifixedLayout';

export class VizPaises extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datos: null,
      atributoSeleccionado: null,
      capaSeleccionada: null,
      baseUrl: props.baseUrl,
      images: null
    };
  }

  render() {
    const t = this.props.t;
    const baseUrl = this.state.baseUrl;
    let datos = this.state.datos;
    if (datos) {
      let maximos = datos.maximos;
      let atrSel = this.state.atributoSeleccionado;
      const pais = this.state.capaSeleccionada
        ? this.state.capaSeleccionada.feature.properties.extraData
        : null;
      if (atrSel) {
        let minimo = { nombre: '0', valor: 0 };
        let maximo = maximos[atrSel];
        if (!maximo.hasOwnProperty('nombre')) {
          maximo = {
            nombre: String(maximo),
            valor: maximo
          };
        } else if (atrSel === 'mejorPosicion') {
          maximo = {
            nombre: t(maximo.nombre),
            valor: maximo.valor
          };
          minimo = { nombre: t('1posicion'), valor: 0 };
        }
        return (
          <div style={{ overflow: 'hidden' }}>
            <Encabezado titulo={t('titulo')} />
            <Row>
              <Col
                xs={{ size: 12, order: 2 }}
                sm={{ size: 12, order: 2 }}
                md={{ size: 4, order: 1 }}
                lg={{ size: 4, order: 1 }}
                xl={{ size: 4, order: 1 }}
                style={{ height: '40em' }}
              >
                <InfoPais
                  pais={pais}
                  atributoSeleccionado={atrSel}
                  onAtributoChange={this.handleAtributoChange.bind(this)}
                  t={t}
                  baseUrl={baseUrl}
                  style={{ height: '100%' }}
                />
              </Col>
              <Col
                xs={{ size: 12, order: 1 }}
                sm={{ size: 12, order: 1 }}
                md={{ size: 8, order: 2 }}
                lg={{ size: 8, order: 2 }}
                xl={{ size: 8, order: 2 }}
                style={{ height: '40em' }}
              >
                <SSemiFixedContainer>
                  <SSemiFixedContainer>
                    <Mapa
                      datos={datos}
                      atributoSeleccionado={atrSel}
                      onCapaChange={this.handleCapaChange.bind(this)}
                      t={t}
                      style={{ height: '100%' }}
                    />
                  </SSemiFixedContainer>
                  <SFixed>
                    <EscalaColores minimo={minimo} maximo={maximo} t={t} />
                    <BarrasPaises datos={datos} pais={pais} atributoSeleccionado={atrSel} t={t} />
                  </SFixed>
                </SSemiFixedContainer>
              </Col>
            </Row>
          </div>
        );
      }
    }
    return <div />;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.baseUrl !== nextState.baseUrl) {
      return true;
    }
    if (this.state.atributoSeleccionado !== nextState.atributoSeleccionado) {
      return true;
    }
    if (
      this.state.capaSeleccionada &&
      nextState.capaSeleccionada &&
      this.state.capaSeleccionada.feature.properties.extraData.iso_code !==
        nextState.capaSeleccionada.feature.properties.extraData.iso_code
    ) {
      return true;
    } else if (this.state.capaSeleccionada) {
      return true;
    } else if (nextState.capaSeleccionada) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.handleUrlUpdate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.baseUrl !== prevState.baseUrl) {
      this.handleUrlUpdate();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ baseUrl: nextProps.baseUrl });
  }

  preloadImages(baseUrl, datos) {
    let images = datos.paises.map((pais, i) => {
      let img = new Image();
      img.src = `${baseUrl}/img/banderas/${pais.iso_code}.svg`;
      return img;
    });
    images.concat(
      datos.paises.map((pais, i) => {
        let img = new Image();
        img.src = `${baseUrl}/img/escudos/${pais.fifa_code}.png`;
        return img;
      })
    );
    images.concat([
      (() => {
        let img = new Image();
        img.src = `${baseUrl}/img/escudos/escudoVacio.svg`;
        return img;
      })(),
      (() => {
        let img = new Image();
        img.src = `${baseUrl}/img/banderas/banderaVacia.svg`;
        return img;
      })()
    ]);
    return images;
  }

  handleUrlUpdate() {
    d3.json(`${this.state.baseUrl}/data/data.json`, (error, datos) => {
      if (error) throw error;
      let maximos = datos.maximos;
      let paisesPorIso = {};
      let paises = datos.paises;
      for (let pais of datos.paises) {
        paisesPorIso[pais.iso_code] = pais;
      }
      let newState = { ...this.state };
      newState.datos = {
        paises: paises,
        paisesPorIso: paisesPorIso,
        maximos: maximos
      };
      newState.atributoSeleccionado = Object.keys(maximos)[0];
      newState.images = this.preloadImages(this.state.baseUrl, datos);
      this.setState(newState);
    });
  }

  handleAtributoChange(atributo) {
    const newState = { ...this.state };
    newState.atributoSeleccionado = atributo;
    this.setState(newState);
  }
  handleCapaChange(capa) {
    const newState = { ...this.state };
    newState.capaSeleccionada = capa;
    this.setState(newState);
  }
}



// WEBPACK FOOTER //
// ./src/components/VizPaises.js